import React from "react";

interface Props {
  count?: number;
}

const ProductSkeleton: React.FC<Props> = ({ count = 8 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white rounded-xl overflow-hidden border animate-pulse">
          {/* IMAGE */}
          <div className="aspect-square bg-gray-200"></div>

          {/* CONTENT */}
          <div className="p-4 space-y-3">
            <div className="h-3 bg-gray-200 rounded w-1/3"></div>

            <div className="h-4 bg-gray-200 rounded w-3/4"></div>

            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ProductSkeleton;
